import GoalOption from './GoalOption'

export default GoalOption
